import {
  Box,
  Button,
  Card,
  CircularProgress,
  Divider,
  Grid,
  IconButton,
  ListItemIcon,
  ListItemText,
  MenuItem,
  TextField,
  Toolbar,
  Tooltip,
  Typography,
} from "@material-ui/core";
import { KeyboardReturnOutlined, MoreHoriz } from "@material-ui/icons";
import AssignmentTurnedInIcon from "@material-ui/icons/AssignmentTurnedIn";
import DeleteOutlinedIcon from "@material-ui/icons/DeleteOutlined";
import ErrorOutlineOutlinedIcon from "@material-ui/icons/ErrorOutlineOutlined";
import SaveAltIcon from "@material-ui/icons/SaveAlt";
import { Alert, Autocomplete } from "@material-ui/lab";
import { styled, withStyles } from "@material-ui/styles";
import { Component, Fragment, useEffect } from "react";
import { toast } from "react-toastify";
import SearchDialog from "../../../components/form-element/SearchDialog";
import { Loader } from "../../../components/Loader";
import { N_A, NA } from "../../../constants/Constants";
import { dateHelperService } from "../../../services/date-helper.service";
import { ROLES } from "../../../services/form.helper.service";
import FormFillerService from "../../../services/review-portal-services/form-filler.service";
import { FORM_MENU_OPTIONS } from "../../../services/review-portal-services/review-form.helper.service";
import ReviewPortalService from "../../../services/review-portal-services/review-portal.service";
import { currentUserState } from "../../../services/session.manager";
import transferIcon from "../../../shared/imgs/transferIcon.svg";
import EditIcon from "@material-ui/icons/Edit";
import {
  checkIfConditionalForm,
  getAllQuestionIdsMap,
  getOptionalEquipmentIds,
  hasPromptEnabledQuestions,
  htmlBase64Utils,
  isGeIdTagValidation,
} from "../../../utility/CommonUtils";
import {
  CACHE_KEY,
  COMPONENT_TYPE,
  CONDITIONAL_FORM,
  DPRO_STATUS,
  EMPTY_STRING,
  GE_ID_KEYS,
  GE_ID_TAG_PROPERTIES,
  GE_ID_TAG_STATUS,
  GEV_ID_LABEL,
  IS_CONDITIONAL_FORM_ENABLED,
  SECTION,
  SUB_SECTION,
} from "../../../utility/Constant";
import localforage from "localforage";
import {
  currentSectionState,
  formErrorState,
  formState,
  FormStore,
  loaderState,
} from "../../store/form.store";
import {
  FORM_STATUS,
  FormApproveMessage,
  FormDeleteMessage,
  FormSiteRequiredMessage,
  FormSiteTurbineRequiredMessage,
  TRANSFER_TEXT,
} from "../../utilities/Constants";
import Components from "../form-element/CompMap";
import ConfirmationDialog from "../form-element/ConfirmationDialog";
import CommentNotification from "../form-element/NotificationBar";
import { fetchTurbinesBySite } from "../../../services/api-service";

const HIDE = "hide";

const styles = (theme) => ({
  formStatus: {
    padding: "7px",
  },
  formLabel: {
    marginTop: "18%",
  },
  title: {
    width: "100%",
    fontWeight: "bold",
    padding: "7px",
    paddingLeft: "18px",
  },
  iconStyle: {
    float: "right",
    marginTop: "-2%",
  },
  root: {
    width: "100%",
    maxHeight: "600px",
    height: "600px",
    overflowY: "auto",
  },
  cancelBtn: {
    border: "1px solid #FFFFFF",
  },
  listIcon: {
    minWidth: 35,
  },
  button: {
    margin: "5px",
    marginLeft: "25%",
  },
  divider: {
    marginBottom: "5px",
  },
  toolBar: {
    backgroundColor: "#6F7282",
    position: "sticky",
    top: "auto",
    bottom: 0,
    zIndex: 5,
    width: "100%",
    marginLeft: "1px",
  },
  flexGrow: {
    flexGrow: 1,
  },
  menuItem: {
    "&:hover": {
      color: "#419BAC",
      backgroundColor: "#eff7f8",
    },
  },
  loader: {
    textAlign: "center",
    position: "absolute",
    top: "30%",
    left: "50%",
  },
  geIdloader: {
    textAlign: "center",
  },
  name: {
    fontFamily: "RobotoLight",
    fontSize: "14px",
    color: "#212121",
  },

  value: {
    color: "#212121",
    fontFamily: "RobotoLight",
    fontSize: "14px",
    fontWeight: "600",
    wordWrap: "break-word",
  },
  gridContainer: {
    gap: "16px",
    padding: "16px 20px",
  },
  card: {
    marginLeft: "16px",
    marginTop: "16px",
  },
  box: {
    display: "flex",
    flexDirection: "column",
  },
  formHeading: {
    fontFamily: "RobotoLight",
    fontWeight: "600",
    fontSize: "16px",
    paddingTop: "16px",
    paddingLeft: "20px",
  },
});

const TitleTooltip = withStyles({
  tooltip: {
    fontSize: "13px",
  },
})(Tooltip);

const Item = styled(Box)(({ theme }) => ({
  ...theme.typography.body2,
}));

const formFillerService = new FormFillerService();
const INITIAL_GE_ID_TAG_DETAILS = {
  geIdTag: null,
  initialGeIdTag: null,
  status: null,
  manufacturerName: null,
  loader: false,
};

const DPRO_SYNC_STATUS = {
  PENDING: "Pending",
  SUCCESS: "Success",
  FAILED: "Failed",
};

class FormView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      form: {},
      loading: false,
      open: false,
      title: "",
      description: "",
      type: "",
      anchorEl: null,
      showComment: false,
      comment: "",
      formStatus: "",
      hasError: false,
      onHoveredTitle: false,
      editMode: false,
      disableSave: false,
      userRole: "",
      ssoOptionsList: [],
      transferedUserId: "",
      isButtonDisabled: false,
      regionOptions: [],
      siteOptions: [],
      turbineOptions: [],
      selectedRegion: null,
      selectedSite: null,
      selectedTurbine: null,
      isDefaultLoading: false,
      geIdTagData: INITIAL_GE_ID_TAG_DETAILS,
      hiddenQuestionIdsMap: [],
      isLoading: false,
    };
    this.formMenuOptions = FORM_MENU_OPTIONS;
    this.reviewPortalService = new ReviewPortalService();
  }

  componentDidMount() {
    this.formSubscription = formState.subscribe((response) => {
      htmlBase64Utils(response, false);
      this.setState({
        form: response,
      });
      if (!this.state.editMode) {
        this.hideFormContent(response);
      }
    });
    this.loaderSubscription = loaderState.subscribe((response) => {
      this.setState({
        loading: response,
      });
    });
    this.currentSectionSubscription = currentSectionState.subscribe((res) => {
      this.setState({ editMode: res ? true : false });
    });
    this.formErrorObservable = formErrorState.subscribe((response) => {
      this.setState({
        disableSave: Object.keys(response).length === 0 ? false : true,
      });
    });
    this.currentUserSubscription = currentUserState.subscribe((user) => {
      this.setState({ userRole: user.userRole });
    });
  }

  resetGeIdTaggingState = () => {
    this.setState({ geIdTagData: INITIAL_GE_ID_TAG_DETAILS });
  };

  hideFormContent = async (formData) => {
    this.setState({ isLoading: true });
    const form = formData || this.state.form;
    const computedHiddenIds = {};

    const equipmentIds = await getOptionalEquipmentIds(form);
    const allQuestionIdsMap = getAllQuestionIdsMap(form);

    const iterateChildrens = (children, parentId) => {
      children?.forEach((child) => {
        let currentParentId = parentId;

        if (
          child?.componentType === SECTION ||
          child?.componentType === SUB_SECTION
        ) {
          currentParentId = child?.elementId;
          if (!computedHiddenIds.hasOwnProperty(child?.elementId)) {
            computedHiddenIds[child?.elementId] = [];
          }
        } else {
          if (
            form?.siteId &&
            form?.turbineId &&
            child?.properties?.hasOptionalEquipmentValue
          ) {
            if (
              !equipmentIds?.includes(
                Number(child?.properties?.hasOptionalEquipmentValue),
              )
            )
              if (
                !computedHiddenIds[currentParentId]?.includes(child?.elementId)
              )
                computedHiddenIds[currentParentId]?.push(child?.elementId);
          }
          if (child?.conditional?.length && child?.answer?.length) {
            const answerId =
              child?.componentType === COMPONENT_TYPE.RADIO_BUTTON
                ? child?.answer?.[0]?.answerValue?.id
                : child?.answer?.[0]?.answerValue?.[0]?.id;
            const [conditionalAnswer] = child?.conditional?.filter(
              (condition) => condition?.id === answerId,
            );
            if (conditionalAnswer) {
              const answerLogicHiddenIds = conditionalAnswer?.actions
                ?.find((action) => action?.name === HIDE)
                ?.targets?.map((target) => target?.elementId);
              if (answerLogicHiddenIds?.length) {
                for (const elementId of answerLogicHiddenIds) {
                  Object.keys(allQuestionIdsMap)?.forEach((parentId) => {
                    if (allQuestionIdsMap[parentId]?.includes(elementId)) {
                      if (!computedHiddenIds.hasOwnProperty(parentId))
                        computedHiddenIds[parentId] = [];
                      if (!computedHiddenIds[parentId]?.includes(elementId))
                        computedHiddenIds[parentId].push(elementId);
                    }
                  });
                }
              }
            }
          }
          if (
            checkIfConditionalForm(form) &&
            form.componentName &&
            Array.isArray(child.universalTagging) &&
            child.universalTagging.length > 0 &&
            !child.universalTagging.includes(form.componentName)
          ) {
            if (!computedHiddenIds[parentId]?.includes(child?.elementId))
              computedHiddenIds[parentId]?.push(child?.elementId);
          }
        }

        if (child?.children && child?.children?.length) {
          iterateChildrens(child?.children, currentParentId);
        }
      });
    };

    iterateChildrens(form?.children, undefined);

    this.setState({
      hiddenQuestionIdsMap: computedHiddenIds,
      isLoading: false,
    });
  };

  componentWillUnmount() {
    this.formSubscription.unsubscribe();
    this.loaderSubscription.unsubscribe();
    this.currentSectionSubscription.unsubscribe();
    this.currentUserSubscription.unsubscribe();
    this.formErrorObservable.unsubscribe();
    this.props.handleIsLoading();
  }

  handleDelete = () => {
    this.setState({
      type: "delete",
      open: true,
      title: "DELETE FORM",
      description: FormDeleteMessage,
    });
  };

  handleEditSiteAndTurbine = async () => {
    this.setState(
      {
        type: "editSiteTurbine",
        open: true,
        title: "Assign/Reassign Pad",
        description: "",
      },
      () => {
        this.populateEditSiteTurbineDefaults();
      },
    );
  };

  handleTransfer = () => {
    this.setState({
      type: TRANSFER_TEXT,
      open: true,
      title: "TRANSFER FORM",
      description: "",
    });
  };

  handleApprove = () => {
    this.setState({
      type: "approve",
      open: true,
      formStatus: "Approved",
      title: "APPROVE FORM",
      description: FormApproveMessage,
    });
  };

  onSaveSiteTurbine = () => {
    const { selectedRegion, selectedSite, selectedTurbine, regionOptions, form } =
      this.state;

    const isTurbineApplicable = !!form?.turbineId;

    if (!selectedRegion || !selectedSite || (isTurbineApplicable && !selectedTurbine)) {
      toast.error(
        isTurbineApplicable
          ? FormSiteTurbineRequiredMessage
          : FormSiteRequiredMessage,
      );
      return;
    }
    let regionObj = null;
    if (
      selectedRegion &&
      typeof selectedRegion === "object" &&
      selectedRegion.siteGroupId
    ) {
      regionObj = selectedRegion;
    } else if (regionOptions && regionOptions.length > 0) {
      regionObj = regionOptions.find(
        (r) => String(r.siteGroupId) === String(selectedRegion),
      );
    }
    if (!regionObj && regionOptions && regionOptions.length > 0) {
      regionObj = regionOptions[0];
    }
    const regionId =
      regionObj && regionObj.siteGroupId ? regionObj.siteGroupId : "";
    const regionName =
      regionObj && regionObj.siteGroupName ? regionObj.siteGroupName : "";

    const turbineId = isTurbineApplicable ? selectedTurbine.windTurbineId : "";
    const turbineName = isTurbineApplicable
      ? selectedTurbine.properties?.shortName || selectedTurbine.turbineName || ""
      : "";

    // Update FormStore.updatedAnswers with new values
    const formStore = FormStore.sharedInstance();
    if (formStore.updatedAnswers) {
      formStore.updatedAnswers.regionId = regionId;
      formStore.updatedAnswers.regionName = regionName;
      formStore.updatedAnswers.siteId = selectedSite.siteId;
      formStore.updatedAnswers.siteName =
        selectedSite.properties?.name || selectedSite.siteName || "";
      formStore.updatedAnswers.turbineId = turbineId;
      formStore.updatedAnswers.turbineName = turbineName;
    }
    const payload = {
      regionId: regionId,
      regionName: regionName,
      siteId: selectedSite.siteId,
      siteName: selectedSite.properties?.name || selectedSite.siteName || "",
      turbineId: turbineId,
      turbineName: turbineName,
    };

    FormStore.sharedInstance().saveSiteTurbineDetails(
      payload,
      this.enableIsButtonDisabled,
    );
  };

  handleClose = () => {
    this.setState({
      open: false,
      comment: "",
      showComment: false,
      hasError: false,
    });
  };

  deleteForm = async () => {
    if (this.state.form !== undefined) {
      const selectedForm = this.state.form;
      this.setState({ isButtonDisabled: true });
      try {
        await FormStore.sharedInstance().deleteForm(
          selectedForm.formDataId,
          this.enableIsButtonDisabled,
        );
      } catch (error) {
        this.setState({ isButtonDisabled: false });
      }
      this.handleClose();
    }
    this.props.handleIsLoading();
  };

  downloadForm = async () => {
    if (this.state.form !== undefined) {
      this.setState({ isButtonDisabled: true });
      const selectedForm = this.state.form;
      try {
        await FormStore.sharedInstance().downloadForm(
          selectedForm,
          this.enableIsButtonDisabled,
        );
      } catch (error) {
        this.setState({ isButtonDisabled: false });
      }
    }
    this.props.handleIsLoading();
  };

  enableIsButtonDisabled = () => {
    this.setState({ isButtonDisabled: false });
  };

  approveForm = async () => {
    if (isGeIdTagValidation(this.state.form.children)) {
      await this.validateGeId(this.state.form.formDataId);
    }
    if (
      !checkIfConditionalForm(this.state.form) ||
      !isGeIdTagValidation(this.state.form.children) ||
      (checkIfConditionalForm(this.state.form) &&
        this.state.geIdTagData.status === GE_ID_TAG_STATUS.VALID)
    ) {
      this.setState({ isButtonDisabled: true });
      var payload = {};
      if (this.state.form !== undefined) {
        const selectedForm = this.state.form;
        payload.id = selectedForm.formDataId;
      } else {
        payload.id = "";
      }
      payload.formStatus = this.state.formStatus;
      payload.comments = this.state.comment;
      try {
        await FormStore.sharedInstance().approveForm(
          payload,
          this.enableIsButtonDisabled,
        );
      } catch (error) {
        this.setState({ isButtonDisabled: false });
      }
      this.formSubscription = formState.subscribe((response) => {
        this.setState({
          form: response,
        });
      });
    } else {
      this.setState({ isButtonDisabled: false });
    }
    this.handleClose();
    this.props.handleIsLoading();
  };

  onSelectRejectForm = (e) => {
    this.setState({
      showComment: true,
      formStatus: "Rejected",
    });
  };

  populateEditSiteTurbineDefaults = async () => {
    try {
      const { form } = this.state;
      const regionId = form.regionId;
      const siteId = form.siteId;
      const turbineId = form.turbineId;
      this.setState({ isDefaultLoading: true });

      // Read regions & sites directly from IndexedDB cache — no API call
      const cachedRegions = await localforage.getItem(CACHE_KEY.REGIONS);
      const cachedSites = regionId
        ? await localforage.getItem(`${regionId}-${CACHE_KEY.SITES}`)
        : null;
      // Turbines are cache-backed; first load may hit API, subsequent calls use cache
      const cachedTurbines = siteId ? await fetchTurbinesBySite(siteId) : [];

      const regions = cachedRegions || [];
      const sites = cachedSites || [];
      const turbines = cachedTurbines?.turbines || cachedTurbines || [];

      this.setState({
        regionOptions: regions,
        siteOptions: sites,
        turbineOptions: turbines,
        selectedRegion: regionId ?? "",
        selectedSite:
          sites.find((s) => String(s.siteId) === String(siteId)) || null,
        selectedTurbine:
          turbines.find((t) => String(t.windTurbineId) === String(turbineId)) ||
          null,
        isDefaultLoading: false,
      });
    } catch (e) {
      console.error(e);
      this.setState({ isDefaultLoading: false });
      toast.error("Failed to populate Site / Turbine");
    }
  };

  onRegionChange = async (event) => {
    const regionId = event.target.value;
    // Read sites for the selected region directly from IndexedDB cache
    const cachedSites = await localforage.getItem(
      `${regionId}-${CACHE_KEY.SITES}`,
    );
    const sites = cachedSites || [];

    this.setState({
      selectedRegion: regionId,
      siteOptions: sites,
      selectedSite: null,
      turbineOptions: [],
      selectedTurbine: null,
    });
  };

  onSiteChange = async (_event, site) => {
    if (!site) {
      this.setState({
        selectedSite: null,
        turbineOptions: [],
        selectedTurbine: null,
      });
      return;
    }

    const cachedTurbines = await fetchTurbinesBySite(site.siteId);

    this.setState({
      selectedSite: site,
      turbineOptions: cachedTurbines?.turbines || cachedTurbines || [],
      selectedTurbine: null,
    });
  };

  onTurbineChange = (_event, turbine) => {
    this.setState({ selectedTurbine: turbine });
  };

  onSelectApproveForm = () => {
    this.setState({
      showComment: true,
      formStatus: "Approved",
    });
  };

  changeHandler = (event) => {
    this.setState({
      comment: event.target.value,
    });
  };

  rejectForm = async () => {
    const isValid = this.validateRejectForm();
    if (isValid) {
      var payload = {};
      if (this.state.form !== undefined) {
        const selectedForm = this.state.form;
        payload.id = selectedForm.formDataId;
      } else {
        payload.id = "";
      }
      payload.formStatus = this.state.formStatus;
      payload.comments = this.state.comment;
      this.setState({ isButtonDisabled: true });
      try {
        await FormStore.sharedInstance().rejectForm(
          payload,
          this.enableIsButtonDisabled,
        );
      } catch (error) {
        this.setState({ isButtonDisabled: false });
      }
      this.formSubscription = formState.subscribe((response) => {
        this.setState({
          form: response,
        });
      });
    }
    this.setState({
      hasError: true,
    });
    this.props.handleIsLoading();
  };

  validateRejectForm = () => {
    const { form, comment, formStatus } = this.state;

    const isCommentValid =
      comment && comment.trim().length > 0 && !comment.startsWith(" ");

    return form?.formDataId && isCommentValid && formStatus;
  };

  getHelperTextForComment = (value) => {
    let helperText = "";
    if (this.state.hasError) {
      if (!value || value.trim().length === 0 || value.startsWith(" ")) {
        helperText = "Comment is required!";
      } else {
        return;
      }
    }
    return helperText;
  };

  showFormMenu = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  cancelForm = () => {
    this.setState({
      comment: "",
    });
    this.handleCloseMenu();
  };

  stopPropagation = (e) => {
    e.stopPropagation();
  };

  onClickFormName = () => {
    this.setState({
      onHoveredTitle: true,
    });
  };

  handleCloseMenu = () => {
    this.setState({
      anchorEl: null,
      hasError: false,
      showComment: false,
      comment: "",
    });
  };

  updateGeIdTagData = (form) => {
    const { geIdTagDetails = {} } = form || {};
    if (geIdTagDetails) {
      for (const key in geIdTagDetails) {
        if (key === GE_ID_TAG_PROPERTIES.GE_ID_TAG) {
          this.updateGeIdTagProperty(
            GE_ID_TAG_PROPERTIES.INITIAL_GE_ID_TAG,
            geIdTagDetails[key],
          );
        }
        this.updateGeIdTagProperty(key, geIdTagDetails[key]);
      }
    }
  };

  resetForm = () => {
    FormStore.sharedInstance().resetForm();
    if (checkIfConditionalForm(this.state.form))
      this.updateGeIdTagData(this.state.form);
    this.setState({ editMode: false });
    this.props.handleIsLoading();
  };

  saveForm = async () => {
    this.setState({ isButtonDisabled: true });
    try {
      await FormStore.sharedInstance().saveForm(this.enableIsButtonDisabled);
    } catch (error) {
      this.setState({ isButtonDisabled: false });
    }
    this.props.handleIsLoading();
  };

  getCategory = (name) => {
    let groupCategory = "";
    this.state.form?.formCategories?.filter((formCategory) => {
      if (formCategory.categoryType === name) {
        groupCategory = formCategory.categoryName;
      }
      return groupCategory;
    });
    return groupCategory !== "" ? groupCategory : NA;
  };

  // Transform Autocomplete onChange
  handleTransformChange = (newValue) => {
    if (newValue.length > 0) {
      this.reviewPortalService
        .getAllUsersListAutoComplete(newValue)
        .then((response) => {
          this.setState({
            ssoOptionsList: response,
          });
        });
    } else {
      this.setState({
        ssoOptionsList: [],
      });
    }
  };

  // Handle selected option from the Email or SSO
  handleTransferId = (selecetedOption) => {
    this.setState({
      transferedUserId: !selecetedOption ? {} : selecetedOption,
    });
  };

  // Submit Transfer Form
  handleApproveTransferForm = () => {
    let formDetails = {
      formDataId: this.state.form.formDataId,
      transferedUserId: this.state.transferedUserId.id,
    };
    this.setState({ isButtonDisabled: true });
    this.reviewPortalService
      .approveTransferForm(formDetails)
      .then((response) => {
        if (response.status !== 200) {
          this.setState({ isButtonDisabled: false });
          toast.error("Could not transform the form");
          return;
        }
        toast.success("Form Transferred successfully");
        this.setState({
          transferedUserId: {},
          ssoOptionsList: [],
        });
        // Re-Trigger the Card Details Api
        this.props.getCheckedCardDetails(this.state.form.formDataId);
        this.handleClose();
        this.setState({ isButtonDisabled: false });
      });
  };

  validateGeId = async (formDataId) => {
    try {
      this.setState({ isButtonDisabled: true });
      this.updateGeIdTagProperty(GE_ID_TAG_PROPERTIES.LOADER, true);
      this.handleCloseMenu();
      const geIdTagToValidate = (
        this.state.geIdTagData?.geIdTag ??
        this.state.geIdTagData?.initialGeIdTag ??
        this.state.form?.geIdTagDetails?.geIdTag ??
        EMPTY_STRING
      ).trim();
      const result = await formFillerService.validateGeIdTag(
        formDataId,
        geIdTagToValidate,
        true,
      );
      if (result.data[GE_ID_KEYS.STATUS] === GE_ID_TAG_STATUS.VALID) {
        this.updateGeIdTagProperty(
          GE_ID_TAG_PROPERTIES.STATUS,
          GE_ID_TAG_STATUS.VALID,
        );
        this.updateGeIdTagProperty(
          GE_ID_TAG_PROPERTIES.MANUFACTURER_NAME,
          result.data[GE_ID_KEYS?.TAG_DETAILS][GE_ID_KEYS.VENDOR_NAME],
        );
        this.updateGeIdTagProperty(GE_ID_TAG_PROPERTIES.LOADER, false);
      } else if (result.data[GE_ID_KEYS.STATUS] === GE_ID_TAG_STATUS.INVALID) {
        this.updateGeIdTagProperty(
          GE_ID_TAG_PROPERTIES.STATUS,
          GE_ID_TAG_STATUS.INVALID,
        );
        this.updateGeIdTagProperty(
          GE_ID_TAG_PROPERTIES.MANUFACTURER_NAME,
          null,
        );
        this.updateGeIdTagProperty(GE_ID_TAG_PROPERTIES.LOADER, false);
      }
    } catch (error) {
      this.setState({ isButtonDisabled: false });
      this.updateGeIdTagProperty(GE_ID_TAG_PROPERTIES.LOADER, false);
      console.error(error);
      toast.error(`${GEV_ID_LABEL} Tag validation failed!`);
    } finally {
      this.setState({ isButtonDisabled: false });
      this.updateGeIdTagProperty(GE_ID_TAG_PROPERTIES.LOADER, false);
    }
  };

  validatePromptIdTag = async (formDataId) => {
    try {
      this.setState({ isButtonDisabled: true });
      this.handleCloseMenu();
      await formFillerService.validatePromptIdTag(formDataId, false, true);
      toast.warn(
        "Validation request submitted. You will receive an email notification with PDF link once the AI analysis is complete."
      );
    } catch (error) {
      console.error(error);
      toast.error("AI verification validation failed. Please try again.");
    } finally {
      this.setState({ isButtonDisabled: false });
    }
  };

  validateFormDataTags = async (formDataId) => {
    const children = this.state.form?.children || [];
    const hasGeIdValidation = isGeIdTagValidation(children);
    const hasPromptValidation = hasPromptEnabledQuestions(children);
    const isCompletedForm =
      this.state.form?.formStatus === FORM_STATUS.COMPLETED;
    const shouldRunPromptValidation = hasPromptValidation && isCompletedForm;

    if (!hasGeIdValidation && !shouldRunPromptValidation) {
      return;
    }

    if (hasGeIdValidation) {
      await this.validateGeId(formDataId);
    }

    if (shouldRunPromptValidation) {
      await this.validatePromptIdTag(formDataId);
    }
  };

  updateGeIdTagProperty = (key, value) => {
    this.setState((prevState) => ({
      geIdTagData: {
        ...prevState.geIdTagData,
        [key]: value,
      },
    }));
  };

  getUniversalSelectedValue = (
    { locationType, componentName } = {},
    universalTypeName,
  ) => {
    const index = locationType
      ?.split(CONDITIONAL_FORM.UNIVERSAL_TAGGING_SPLIT)
      ?.indexOf(universalTypeName);
    return componentName?.split(CONDITIONAL_FORM.UNIVERSAL_TAGGING_SPLIT)?.[
      index
    ];
  };

  getGeIdValidationAlertConfig = (status, geIdTag) => {
    if (status === GE_ID_TAG_STATUS.VALID) {
      return {
        severity: "success",
        message: `${GEV_ID_LABEL} Tag (${geIdTag}) is Valid`,
      };
    }

    if (status === GE_ID_TAG_STATUS.INVALID && geIdTag === EMPTY_STRING) {
      return {
        severity: "warning",
        message: `${GEV_ID_LABEL} Tag is Empty`,
      };
    }

    if (status === GE_ID_TAG_STATUS.INVALID) {
      return {
        severity: "error",
        message: `${GEV_ID_LABEL} Tag (${geIdTag}) is Invalid`,
      };
    }

    return null;
  };

  renderGeIdValidationAlert = (status, geIdTag) => {
    const alertConfig = this.getGeIdValidationAlertConfig(status, geIdTag);

    if (!alertConfig) {
      return null;
    }

    return (
      <Grid>
        <Alert severity={alertConfig.severity}>
          <strong>{alertConfig.message}</strong>
        </Alert>
      </Grid>
    );
  };

  render() {
    const { classes } = this.props;
    const { geIdTag, status, manufacturerName, loader } =
      this.state.geIdTagData;

    const isFinalState =
      this.state.form?.formStatus === FORM_STATUS.APPROVED ||
      this.state.form?.formStatus === FORM_STATUS.REJECTED;

    const dataSections = [
      {
        label: "Status:",
        value: this.state.form?.formStatus,
        color:
          this.state.form?.formStatus?.toUpperCase() ===
          FORM_STATUS.COMPLETED?.toUpperCase()
            ? "#001096"
            : this.state.form?.formStatus?.toUpperCase() ===
                FORM_STATUS.REJECTED?.toUpperCase()
              ? "#FE1919"
              : this.state.form?.formStatus?.toUpperCase() ===
                  FORM_STATUS.APPROVED?.toUpperCase()
                ? "#22B40C"
                : this.state.form?.formStatus?.toUpperCase() ===
                    FORM_STATUS.INPROGRESS?.toUpperCase()
                  ? "#E9745D"
                  : "black",
        fontWeight: "600",
        textTrasform: "capitalize",
        xs: 2,
      },
      {
        label: "Windfarm:",
        value: this.state.form?.siteName || NA,
        xs: isFinalState ? 2 : 3,
      },
      {
        label: "Record Id:",
        value: this.state.form?.formDataId || NA,
        xs: 2,
      },
      {
        label:
          this.state.form?.formStatus === FORM_STATUS.INPROGRESS
            ? "Last updated by:"
            : "Completed By:",
        value:
          this.state.form?.formStatus === FORM_STATUS.INPROGRESS
            ? `${this.state.form?.submittedBy?.userFirstName || ""} ${
                this.state.form?.submittedBy?.userLastName || ""
              }`.trim() || NA
            : `${this.state.form?.completedBy?.userFirstName || ""} ${
                this.state.form?.completedBy?.userLastName || ""
              }`.trim() || NA,
        variant: "body2",
        xs: isFinalState ? 2 : 3,
      },
      ...(isFinalState
        ? [
            {
              label:
                this.state.form?.formStatus === FORM_STATUS.APPROVED
                  ? "Approved By:"
                  : "Rejected By:",
              value:
                `${this.state.form?.submittedBy?.userFirstName || ""} ${
                  this.state.form?.submittedBy?.userLastName || ""
                }`.trim() || NA,
              xs: 2,
            },
          ]
        : []),
      {
        label: "Group:",
        value: this.getCategory("Group"),
        xs: 2,
      },
      {
        label: "Turbine:",
        value: this.state.form?.turbineId
          ? this.state.form?.turbineName + " | " + this.state.form?.turbineId
          : N_A,
        xs: isFinalState ? 2 : 3,
      },
      {
        label: "Version:",
        value: this.state.form?.version || NA,
        xs: 2,
      },
      {
        label:
          this.state.form?.formStatus === FORM_STATUS.INPROGRESS
            ? "Last updated date:"
            : "Completed date:",
        value: dateHelperService.formattedDateFromUTS(
          this.state.form?.formStatus === FORM_STATUS.INPROGRESS
            ? this.state.form?.updatedDate
            : this.state.form?.completedDate,
        ),
        xs: isFinalState ? 2 : 3,
      },
      ...(isFinalState
        ? [
            {
              label:
                this.state.form?.formStatus === FORM_STATUS.APPROVED
                  ? "Approved date:"
                  : "Rejected date:",
              value: dateHelperService.formattedDateFromUTS(
                this.state.form?.updatedDate,
              ),
              xs: 2,
            },
          ]
        : []),
      ...(checkIfConditionalForm(this.state.form)
        ? [
            {
              label: "Location Type:",
              value:
                this.getUniversalSelectedValue(
                  this.state.form,
                  "Location Type",
                ) || NA,
              xs: 2,
            },
            {
              label: "Component Name:",
              value:
                this.getUniversalSelectedValue(
                  this.state.form,
                  "Component Type",
                ) || NA,
              xs: isFinalState ? 2 : 3,
            },
            {
              label: "GEV ID Tag:",
              value: geIdTag ?? EMPTY_STRING,
              xs: 2,
            },
            {
              label: "Manufacturer Name:",
              value: manufacturerName ?? EMPTY_STRING,
              xs: 2,
            },
            ...(this.state.form.formStatus === FORM_STATUS.APPROVED
              ? [
                  {
                    label: "DPRO Sync:",
                    value:
                      DPRO_SYNC_STATUS[this.state.form.dproStatus] ??
                      EMPTY_STRING,
                    color:
                      this.state.form.dproStatus === DPRO_STATUS.SUCCESS
                        ? "#22B40C"
                        : this.state.form.dproStatus === DPRO_STATUS.FAILED
                          ? "#FE1919"
                          : "#E9745D",
                    xs: 2,
                  },
                ]
              : []),
          ]
        : []),
    ];
    return this.state.loading || this.state.isLoading ? (
      <div className={classes.loader}>
        <Loader loading={true} />
      </div>
    ) : (
      <Fragment>
        <FormTitle
          id="formTitle"
          title={this.state.form.form_name}
          form={this.state.form}
          className={classes}
          deleteForm={this.deleteForm}
          handleClose={this.handleClose}
          open={this.state.open}
          popupTitle={this.state.title}
          description={this.state.description}
          type={this.state.type}
          handleDelete={this.handleDelete}
          regionOptions={this.state.regionOptions}
          siteOptions={this.state.siteOptions}
          turbineOptions={this.state.turbineOptions}
          selectedRegion={this.state.selectedRegion}
          selectedSite={this.state.selectedSite}
          selectedTurbine={this.state.selectedTurbine}
          onRegionChange={this.onRegionChange}
          onSiteChange={this.onSiteChange}
          onTurbineChange={this.onTurbineChange}
          isDefaultLoading={this.state.isDefaultLoading}
          handleEditSiteAndTurbine={this.handleEditSiteAndTurbine}
          onSaveSiteTurbine={this.onSaveSiteTurbine}
          handleTransfer={this.handleTransfer}
          handleApprove={this.handleApprove}
          approveForm={this.approveForm}
          rejectForm={this.rejectForm}
          showFormMenu={this.showFormMenu}
          anchorEl={this.state.anchorEl}
          onSelectRejectForm={this.onSelectRejectForm}
          onSelectApproveForm={this.onSelectApproveForm}
          downloadForm={this.downloadForm}
          showComment={this.state.showComment}
          comment={this.state.comment}
          changeHandler={this.changeHandler}
          getHelperTextForComment={this.getHelperTextForComment}
          cancelForm={this.cancelForm}
          hasError={this.state.hasError}
          stopPropagation={this.stopPropagation.bind(this)}
          onClickFormName={this.onClickFormName}
          onHoveredTitle={this.state.onHoveredTitle}
          userRole={this.state.userRole}
          handleCloseMenu={this.handleCloseMenu}
          ssoOptionsList={this.state.ssoOptionsList}
          transferedUserId={this.state.transferedUserId}
          handleTransformChange={this.handleTransformChange}
          handleTransferId={this.handleTransferId}
          handleClearFormAutoComplete={this.handleClearFormAutoComplete}
          handleApproveTransferForm={this.handleApproveTransferForm}
          isButtonDisabled={this.state.isButtonDisabled}
          geIdTagData={this.state.geIdTagData}
          updateGeIdTagProperty={this.updateGeIdTagProperty}
          resetGeIdTaggingState={this.resetGeIdTaggingState}
          validateFormDataTags={this.validateFormDataTags}
        />
        <Divider style={{ marginTop: "2px" }} />
        {Object.keys(this.state.form).length > 0 && (
          <Card className={classes.card}>
            {this.state.form.forceSubmit && (
              <Grid>
                <Alert severity="info">
                  <strong>Form Force Submitted</strong>
                </Alert>
              </Grid>
            )}
            <Box className={classes.formHeading}>
              {this.state.form.formName}
            </Box>
            <Grid className={classes.gridContainer} container>
              {dataSections.map((section, index) => (
                <Grid item xs={section.xs} key={index}>
                  <Box className={classes.box}>
                    <Typography
                      variant="caption"
                      color="textSecondary"
                      className={classes.name}
                    >
                      {section.label}
                    </Typography>
                    <Typography
                      variant={section.variant || "caption"}
                      style={{
                        color: section.color || "textSecondary",
                        fontWeight: "600",
                        fontFamily: section.fontFamily || "RobotoLight",
                      }}
                      className={classes.value}
                    >
                      {section.value}
                    </Typography>
                  </Box>
                </Grid>
              ))}
            </Grid>
            {(status !== null || loader) &&
              (loader ? (
                <div className={classes.geIdloader}>
                  <Loader loading={true} />
                </div>
              ) : (
                this.renderGeIdValidationAlert(status, geIdTag)
              ))}
          </Card>
        )}
        <Typography component="div" style={{ paddingRight: "0px" }}>
          <Box p={3} className={classes.root} style={{ paddingRight: "0px" }}>
            <Grid container spacing={3} style={{ padding: "0px" }}>
              <Grid item md={12} xs={12} style={{ paddingRight: "0px" }}>
                <RenderForm
                  form={this.state.form}
                  hiddenQuestionIdsMap={this.state.hiddenQuestionIdsMap}
                  updateGeIdTagProperty={this.updateGeIdTagProperty}
                />
              </Grid>
            </Grid>
          </Box>
          {this.state.editMode && this.state.userRole !== "TECHNICIAN" ? (
            <Toolbar className={classes.toolBar}>
              <span className={classes.flexGrow} />
              <Button
                onClick={this.resetForm}
                variant="outlined"
                className={classes.cancelBtn}
              >
                CANCEL
              </Button>
              <Button
                onClick={this.saveForm}
                disabled={this.state.disableSave || this.state.isButtonDisabled}
                variant="contained"
              >
                SAVE
              </Button>
            </Toolbar>
          ) : null}
        </Typography>
      </Fragment>
    );
  }
}

function FormTitle(props) {
  useEffect(() => {
    return () => {
      props.resetGeIdTaggingState();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const { geIdTagDetails = {} } = props?.form || {};
    if (geIdTagDetails && geIdTag === initialGeIdTag) {
      for (const key in geIdTagDetails) {
        if (key === GE_ID_TAG_PROPERTIES.GE_ID_TAG) {
          props.updateGeIdTagProperty(
            GE_ID_TAG_PROPERTIES.INITIAL_GE_ID_TAG,
            geIdTagDetails[key],
          );
        }
        props.updateGeIdTagProperty(key, geIdTagDetails[key]);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.form]);

  const classes = props.className;
  const { formDataId } = props.form;
  const { initialGeIdTag, geIdTag, status, loader } = props.geIdTagData;
  const isLotoForm = () => {
    if (!props.form || !props.form.formCategories) return false;

    return props.form?.formCategories?.some((cat) =>
      cat.categoryName?.includes("LOTO-"),
    );
  };
  // const isReceivingForm = () => {
  //   if (!props.form || !props.form.formCategories) return false;

  //   return props.form?.formCategories?.some(
  //     (cat) => cat.categoryName === "Receiving",
  //   );
  // };
  const userRole = props.userRole;
  const isTransferAllowedStatus =
    props.form.formStatus === FORM_STATUS.INPROGRESS ||
    props.form.formStatus === FORM_STATUS.REJECTED;
  const showCommentNotification =
    props.form.formStatus === FORM_STATUS.APPROVED ||
    props.form.formStatus === FORM_STATUS.REJECTED;
  return (
    <Fragment>
      <Box sx={{ flexGrow: 1 }}>
        <Grid container>
          <Grid
            item
            xs={showCommentNotification ? 11 : 8}
            md={showCommentNotification ? 11 : 8}
          >
            {showCommentNotification && (
              <CommentNotification
                comment={props.form?.comments}
                type={
                  props.form.formStatus === FORM_STATUS.APPROVED
                    ? "approve"
                    : "reject"
                }
              />
            )}
          </Grid>
          <Grid
            item
            xs={showCommentNotification ? 1 : 4}
            md={showCommentNotification ? 1 : 4}
            alignContent="center"
          >
            <Item>
              <span className={classes.iconStyle}>
                <IconButton
                  id="iconButton"
                  aria-label="threeDots"
                  onClick={props.showFormMenu}
                >
                  <MoreHoriz id="moreHorizIcon" />
                </IconButton>
                <SearchDialog
                  open={Boolean(props.anchorEl)}
                  onCloseMenu={props.handleCloseMenu}
                  name="rejectFormMenu"
                  anchorEl={props.anchorEl}
                  title=""
                  description=""
                >
                  <MenuItem
                    className={classes.menuItem}
                    classes={{ selected: classes.selected }}
                    disabled={
                      !isTransferAllowedStatus ||
                      props.isButtonDisabled ||
                      userRole === ROLES.TECHNICIAN
                    }
                    onClick={props.handleTransfer}
                  >
                    <ListItemIcon className={classes.listIcon}>
                      <img
                        id="transferIcon"
                        alt="Transfer Icon"
                        src={transferIcon}
                        className={classes.imgStyle}
                      />
                    </ListItemIcon>
                    <ListItemText
                      className={classes.menuItemText}
                      primary="Transfer Form"
                      disableTypography
                    ></ListItemText>
                  </MenuItem>
                  <Box display="flex" flexDirection="row" alignItems="center">
                    <MenuItem
                      className={classes.menuItem}
                      classes={{ selected: classes.selected }}
                      style={{ paddingRight: "4px" }}
                      onClick={props.onSelectRejectForm}
                      disabled={
                        props.form.formStatus !== FORM_STATUS.COMPLETED ||
                        props.isButtonDisabled ||
                        userRole === ROLES.TECHNICIAN ||
                        isLotoForm()
                      }
                    >
                      <ListItemIcon className={classes.listIcon}>
                        <KeyboardReturnOutlined id="keyboardreturnIcon" />
                      </ListItemIcon>
                      <ListItemText
                        className={classes.menuItemText}
                        style={{ maxWidth: "max-content" }}
                        primary="Reject Form"
                      ></ListItemText>
                    </MenuItem>
                    {isLotoForm() && (
                      <ListItemIcon>
                        <Tooltip title="LOTO form cannot be rejected">
                          <ErrorOutlineOutlinedIcon
                            id="errorOutlineOutlinedIcon"
                            style={{ color: "#419BAC" }}
                          />
                        </Tooltip>
                      </ListItemIcon>
                    )}
                  </Box>
                  {props.showComment ? (
                    <Box p={3}>
                      <Grid item>
                        <TextField
                          fullWidth
                          label="Comment"
                          multiline
                          minRows="2"
                          name="comment"
                          variant="outlined"
                          value={props.comment}
                          error={
                            props.hasError &&
                            (!props.comment ||
                              props.comment.trim().length === 0 ||
                              props.comment.startsWith(" "))
                          }
                          helperText={props.getHelperTextForComment(
                            props.comment,
                          )}
                          onChange={props.changeHandler}
                          onKeyDown={props.stopPropagation}
                        />
                      </Grid>
                      <div className={classes.buttonsView}>
                        <Button
                          variant="text"
                          className={classes.button}
                          onClick={props.cancelForm}
                        >
                          CANCEL
                        </Button>
                        <Button
                          variant="text"
                          color="primary"
                          disabled={props.isButtonDisabled}
                          onClick={props.rejectForm}
                        >
                          REJECT
                        </Button>
                      </div>
                      <Divider className={classes.divider} />
                    </Box>
                  ) : null}
                  <MenuItem
                    className={classes.menuItem}
                    disabled={props.isButtonDisabled}
                    classes={{ selected: classes.selected }}
                    onClick={props.downloadForm}
                  >
                    <ListItemIcon className={classes.listIcon}>
                      <SaveAltIcon id="downloadIcon" />
                    </ListItemIcon>
                    <ListItemText
                      className={classes.menuItemText}
                      primary="Download"
                      disableTypography
                    ></ListItemText>
                  </MenuItem>
                  <Box display="flex" flexDirection="row" alignItems="center">
                    <MenuItem
                      className={classes.menuItem}
                      classes={{ selected: classes.selected }}
                      style={{ paddingRight: "4px" }}
                      onClick={props.handleDelete}
                      disabled={
                        props.form.formStatus === FORM_STATUS.COMPLETED ||
                        props.isButtonDisabled ||
                        userRole === ROLES.TECHNICIAN ||
                        isLotoForm()
                      }
                    >
                      <ListItemIcon className={classes.listIcon}>
                        <DeleteOutlinedIcon id="deleteIcon" />
                      </ListItemIcon>
                      <ListItemText
                        className={classes.menuItemText}
                        primary="Delete"
                      ></ListItemText>
                    </MenuItem>
                    {isLotoForm() && (
                      <ListItemIcon>
                        <Tooltip title="LOTO form cannot be deleted">
                          <ErrorOutlineOutlinedIcon
                            id="errorOutlineOutlinedIcon"
                            style={{ color: "#419BAC" }}
                          />
                        </Tooltip>
                      </ListItemIcon>
                    )}
                  </Box>
                  {IS_CONDITIONAL_FORM_ENABLED && (
                    <>
                      <MenuItem
                        className={classes.menuItem}
                        disabled={
                          props.form.formStatus === FORM_STATUS.APPROVED ||
                          (!isGeIdTagValidation(props.form.children) &&
                            !(props.form.formStatus === FORM_STATUS.COMPLETED &&
                              hasPromptEnabledQuestions(props.form.children))) ||
                          (isGeIdTagValidation(props.form.children) &&
                            initialGeIdTag !== geIdTag)
                        }
                        onClick={() => props.validateFormDataTags(formDataId)}
                      >
                        <ListItemIcon className={classes.listIcon}>
                          <AssignmentTurnedInIcon id="validateIcon" />
                        </ListItemIcon>
                        <ListItemText
                          className={classes.menuItemText}
                          primary="Validate"
                          disableTypography
                        ></ListItemText>
                      </MenuItem>
                      {props.form.formStatus === FORM_STATUS.COMPLETED &&
                        checkIfConditionalForm(props.form) && (
                          <MenuItem
                            className={classes.menuItem}
                            disabled={props.isButtonDisabled}
                            classes={{ selected: classes.selected }}
                            onClick={props.handleEditSiteAndTurbine}
                          >
                            <ListItemIcon className={classes.listIcon}>
                              <EditIcon id="editIcon" />
                            </ListItemIcon>
                            <ListItemText
                              className={classes.menuItemText}
                              primary="Assign/Reassign Pad"
                              disableTypography
                            ></ListItemText>
                          </MenuItem>
                        )}
                    </>
                  )}
                </SearchDialog>
                {props.form.formStatus === FORM_STATUS.COMPLETED &&
                  userRole !== ROLES.TECHNICIAN && (
                    <TitleTooltip
                      title={
                        checkIfConditionalForm(props.form) &&
                        (!props.form.turbineName ||
                          props.form.turbineName === "Storage NA")
                          ? "Form can't be approved as the turbine is not available"
                          : ""
                      }
                    >
                      <span>
                        <Button
                          variant="contained"
                          onClick={props.handleApprove}
                          disabled={
                            loader ||
                            initialGeIdTag !== geIdTag ||
                            (checkIfConditionalForm(props.form) &&
                              status === GE_ID_TAG_STATUS.INVALID) ||
                            (checkIfConditionalForm(props.form) &&
                              (!props.form.turbineName ||
                                props.form.turbineName === "Storage NA")) ||
                            (checkIfConditionalForm(props.form) &&
                              (!props.form.turbineId ||
                                props.form.turbineId === ""))
                          }
                        >
                          Approve
                        </Button>
                      </span>
                    </TitleTooltip>
                  )}
              </span>
            </Item>
          </Grid>
        </Grid>
      </Box>
      <ConfirmationDialog
        open={Boolean(props.open)}
        onClose={props.handleClose}
        title={props.popupTitle}
        description={props.description}
        onDelete={props.deleteForm}
        onApprove={
          props.type === TRANSFER_TEXT
            ? props.handleApproveTransferForm
            : props.type === "editSiteTurbine"
            ? props.onSaveSiteTurbine
            : props.approveForm
        }
        type={props.type}
        buttonTitle={
          props.type === TRANSFER_TEXT
            ? TRANSFER_TEXT
            : props.type === "editSiteTurbine"
              ? "Save"
              : undefined
        }
        mainButtonDisabled={
          props.type === TRANSFER_TEXT && !props.transferedUserId.id
        }
        dialogWidth={
          (props.type === TRANSFER_TEXT || props.type === "approve") && "400px"
        }
        transferButton={props.type === TRANSFER_TEXT}
        isButtonDisabled={props.isButtonDisabled}
      >
        {isTransferAllowedStatus && props.type === TRANSFER_TEXT && (
            <Autocomplete
              style={{
                padding: "10px 0px",
              }}
              options={props.ssoOptionsList}
              getOptionLabel={(option) => option.label}
              filterOptions={(options, state) => {
                return options.filter(
                  (option) =>
                    option?.label
                      ?.toLowerCase()
                      ?.includes(state?.inputValue?.toLowerCase()) ||
                    option?.email
                      ?.toLowerCase()
                      ?.includes(state?.inputValue?.toLowerCase()),
                );
              }}
              getOptionSelected={(option, value) => option.id === value.id}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  label="Email Or SSO"
                />
              )}
              onInputChange={(_event, newValue) =>
                props.handleTransformChange(newValue)
              }
              onChange={(_event, value) => props.handleTransferId(value)}
            />
          )}
        {props.type === "approve" && (
          <Box>
            <TextField
              fullWidth
              label="Approval comments (optional)"
              multiline
              minRows="2"
              name="comment"
              variant="outlined"
              value={props.comment}
              onChange={props.changeHandler}
              onKeyDown={props.stopPropagation}
              inputProps={{ maxLength: 255 }}
            />
          </Box>
        )}
        {props.type === "editSiteTurbine" && (
          <Box display="flex" flexDirection="column" width={400} gridGap={16}>
            {props.isDefaultLoading ? (
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                p={3}
              >
                <CircularProgress size={30} />
              </Box>
            ) : (
              <>
                <TextField
                  select
                  label="Region"
                  value={props.selectedRegion ?? ""}
                  onChange={props.onRegionChange}
                  fullWidth
                  variant="outlined"
                  disabled={true}
                >
                  {props.regionOptions.map((region) => (
                    <MenuItem
                      key={region.siteGroupId}
                      value={region.siteGroupId}
                    >
                      {region.siteGroupName}
                    </MenuItem>
                  ))}
                </TextField>
                <Autocomplete
                  options={props.siteOptions || []}
                  value={props.selectedSite}
                  getOptionLabel={(o) => o?.properties?.name || ""}
                  getOptionSelected={(option, value) =>
                    option.siteId === value.siteId
                  }
                  onChange={props.onSiteChange}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Windfarm"
                      variant="outlined"
                    />
                  )}
                />
                <Autocomplete
                  options={props.turbineOptions || []}
                  value={props.selectedTurbine}
                  disabled={!props.form.turbineId}
                  getOptionLabel={(o) => o?.properties?.shortName || ""}
                  getOptionSelected={(option, value) =>
                    option.windTurbineId === value.windTurbineId
                  }
                  onChange={props.onTurbineChange}
                  renderInput={(params) => (
                    <TextField {...params} label="Turbine" variant="outlined" />
                  )}
                />
              </>
            )}
          </Box>
        )}
      </ConfirmationDialog>
    </Fragment>
  );
}

function RenderForm(props) {
  if (props.form.children !== undefined && props.form.children.length !== 0) {
    const TagName = Components["section"];
    const items = props.form.children.map((item, key) => (
      <TagName
        key={key}
        section={item}
        formStatus={props.form.formStatus}
        hiddenQuestionIdsMap={props.hiddenQuestionIdsMap}
        updateGeIdTagProperty={props?.updateGeIdTagProperty}
        formDataId={props.form.formDataId}
      />
    ));
    return items;
  }
  return null;
}

export { FormView };
export default withStyles(styles, { withTheme: true })(FormView);
